module.exports = __webpack_public_path__ + "static/img/11.3900225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/11.jpg
// module id = VhbN
// module chunks = 0